import { useQuery } from '@tanstack/react-query';

import { apiFetchToSSR } from '../context/ApiContext';
import { Claims } from '../types';

const useClaims = () => {
  const {
    refetch: fetchData,
    data: claimsData,
    isLoading,
  } = useQuery<Claims>({
    queryKey: ['claims'],
    queryFn: () => apiFetchToSSR('/claims', {}, 'GET'),
  });

  return { isLoading, claims: claimsData, fetchData };
};

export default useClaims;
